import { EnvironmentUrls } from 'Roblox';
import angular from 'angular';
import recommendationsModule from '../recommendationsModule.js';

function recommendationsService(
  httpService,
  recommendationsConstants,
  thumbnailConstants,
  creatorNameUtilities,
  $filter
) {
  'ngInject';

  const { recommendationTypes } = recommendationsConstants;

  function getBundleUrl(bundleId) {
    return `${EnvironmentUrls.websiteUrl}/bundles/${bundleId}`;
  }

  function getProfileLink(userId) {
    return `${EnvironmentUrls.websiteUrl}/users/${userId}/profile`;
  }
  // TODO: FOR ROLLOUT FALLBACK
  function overrideRecommendationTypes(overrideRecommendationTypes) {
    if (!overrideRecommendationTypes) {
      return false;
    }
    angular.forEach(overrideRecommendationTypes, (value, key) => {
      recommendationTypes[key.toLowerCase()] = value;
    });
  }

  function isRecommendationAllowed(recommendationType, recommendationSubtype) {
    if (recommendationType === recommendationTypes.bundle) {
      return true;
    }
    // do not show recommendations for Game Passes and Badges
    return (
      recommendationSubtype > 0 &&
      recommendationSubtype !== recommendationsConstants.recommendationSubtypes.gamePasses &&
      recommendationSubtype !== recommendationsConstants.recommendationSubtypes.badges
    );
  }

  function translateBundleResult(result) {
    const creatorName = result.creator.name;
    return {
      id: result.id,
      name: result.name,
      price: result.product.priceInRobux,
      absoluteUrl: getBundleUrl(result.id),
      audioUrl: null,
      creator: {
        id: result.creator.id,
        name: creatorName,
        nameForDisplay: $filter('escapeHtml')(
          creatorNameUtilities.getNameForDisplay(result.creator)
        ),
        type: result.creator.type,
        profileLink: getProfileLink(result.creator.id)
      },
      thumbnail: {
        type: thumbnailConstants.thumbnailTypes.bundleThumbnail
      },
      product: {
        id: result.product.id,
        isForSale: result.product.isForSale,
        isFree: result.product.isFree,
        noPriceText: result.product.noPriceText
      }
    };
  }

  function beginUpdateRecommendedItemsForBundle(recommendationTargetId, numItems) {
    const params = {
      numItems
    };

    const urlConfig = {
      url: `${EnvironmentUrls.catalogApi}/v1/bundles/${recommendationTargetId}/recommendations`
    };

    return httpService.httpGet(urlConfig, params).then(result => {
      if (result && result.data) {
        return result.data.map(translateBundleResult);
      }
      return [];
    });
  }

  function getCatalogMetadata() {
    return httpService.httpGet({
      url: `${EnvironmentUrls.catalogApi}/v1/catalog/metadata`,
      retryable: true,
      withCredentials: true
    });
  }

  function getRecommendationMetadata(pageName) {
    const params = {
      page: pageName
    };

    const urlConfig = {
      url: `${EnvironmentUrls.catalogApi}/v1/recommendations/metadata`
    };

    return httpService.httpGet(urlConfig, params).then(function success(result) {
      const returnResult = angular.copy(result);
      if (result) {
        const {
          numOfRecommendationsRetrieved,
          numOfRecommendationsDisplayed,
          carouselTestingVariation,
          isCarouselTestingEnabled,
          isCarouselEnabled
        } = result;
        if (isCarouselEnabled) {
          returnResult.numberOfItems = numOfRecommendationsRetrieved;
          returnResult.isCarouselUIEnabled = true;
        } else if (isCarouselTestingEnabled && carouselTestingVariation > 0) {
          returnResult.numberOfItems = numOfRecommendationsRetrieved;
          returnResult.isCarouselUIEnabled = true;
        } else {
          returnResult.numberOfItems = numOfRecommendationsDisplayed;
        }
      }
      return returnResult;
    });
  }

  function translateAssetResult(result) {
    const creatorName = result.creator.name;
    return {
      id: result.item.assetId,
      name: result.item.name,
      price: result.item.price,
      premiumPrice: result.item.premiumPrice,
      absoluteUrl: result.item.absoluteUrl,
      audioUrl: result.item.audioUrl,
      creator: {
        id: result.creator.creatorId,
        name: creatorName,
        nameForDisplay: $filter('escapeHtml')(
          creatorNameUtilities.getNameForDisplay(result.creator)
        ),
        type: result.creator.creatorType,
        profileLink: result.creator.creatorProfileLink
      },
      thumbnail: {
        type: thumbnailConstants.thumbnailTypes.assetThumbnail
      },
      product: {
        id: result.product.id,
        isForSale: result.product.isForSale,
        noPriceText: result.product.noPriceText,
        isFree: result.product.isFree
      }
    };
  }

  function beginUpdateRecommendedItems(
    recommendationTargetId,
    recommendationType,
    recommendationSubtype,
    numItems,
    isRecommendationFromCatalogApiEnabled
  ) {
    if (recommendationType === recommendationTypes.bundle) {
      return beginUpdateRecommendedItemsForBundle(recommendationTargetId, numItems);
    }

    const params = {
      numItems
    };

    if (recommendationTargetId > 0) {
      params.contextAssetId = recommendationTargetId;
    }

    const url = isRecommendationFromCatalogApiEnabled
      ? `${EnvironmentUrls.catalogApi}/v1/recommendations/asset/${recommendationSubtype}`
      : `${EnvironmentUrls.inventoryApi}/v2/recommendations/${recommendationSubtype}`;
    const urlConfig = {
      url
    };

    return httpService.httpGet(urlConfig, params).then(result => {
      if (result && result.data) {
        return result.data.map(translateAssetResult);
      }
      return result;
    });
  }

  return {
    isRecommendationAllowed,
    beginUpdateRecommendedItems,
    getCatalogMetadata,
    getRecommendationMetadata,
    overrideRecommendationTypes
  };
}

recommendationsModule.factory('recommendationsService', recommendationsService);
export default recommendationsService;
